import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import {
  getAllUserMappedToJobAction,
  getClientJobSchedulingListAction,
  resetAllUserMappedToJobList,
  resetClientJobSchedulingList,
  resetClientJobSchedulingTotal,
  resetSchedulingError,
  resetSchedulingMessage,
  resetSchedulingStatusCode,
  resetSchedulingSuccess,
} from "../../../../redux/scheduling";
import {
  getAssignedClientsToUserAction,
  resetSession,
} from "../../../../redux/auth";
import {
  CircularAvatar,
  CommonHeader,
  DropDown,
  EmptyListPage,
  ErrorSuccessModal,
  Loader,
} from "../../../../components/commons";
import {
  ClientType,
  LoginResponseType,
} from "../../../../redux/auth/authTypes";
import { GetAssignedClientsToUserPayloadType } from "../../../../commonTypes/authTypes";
import ReportsDateSelect from "../../../../components/commons/ReportsDateSelect/ReportsDateSelect";
import {
  formatDate,
  getCurrentMonthDates,
  handleDate,
  reverseDateFormat,
} from "../../../../utils/commonFunctions";
import ClientJobScheduleCalendarView from "./ClientJobScheduleCalendarView";
import {
  GetClientJobSchedulingListPayloadType,
  AllUsersMappedToJobListType,
  GetScheduledAllUserMappedToJobPayloadType,
} from "../../../../commonTypes/schedulingTypes";
import {
  ClientJobSchedulingListType,
  SelectOptionType,
} from "../../../../redux/scheduling/schedulingTypes";
import ClientJobScheduleSorting from "../../../../components/Scheduling/ScheduleReports/ClientJobScheduleReport/ClientJobScheduleSorting";
import "../style.scss";
import { getClientDirectoryListAction } from "../../../../redux/clientDirectory";
import useDebounce from "../../../../customHooks/useDebounce";
import Select from "react-select";
import { SelctOptionType } from "../../../../components/DisbursementModule/DisbursementModuleForm/AddEditDisbursementForm";
import {
  getFutureJobsListAction,
  getJobsListAction,
  resetFutureJobsList,
  resetJobsList,
} from "../../../../redux/jobs";
import { JobTrackerListingType } from "../../../../redux/listing/listingTypes";
import { ClientFutureJobListingType } from "../../../../redux/jobs/jobsType";
import { GetJobsPayload } from "../../../../commonTypes/jobsType";

type AppProps = {
  token: string | null;
  fetching: boolean;
  message: string | null;
  error: string | null;
  statusCode: number | null;
  success: number | null;
  totalCount: number;
  loginData: LoginResponseType;
  clientList: ClientType[] | [];
  clientJobSchedulingList: ClientJobSchedulingListType[] | [];
  type?: string;
  totalJobsCount: number;
  futureJobsList: ClientFutureJobListingType[] | [];
  jobsList: [] | JobTrackerListingType[];
  totalClientsCount: any;
  allUserMappedToJob: AllUsersMappedToJobListType[] | [];
  dispatchResetSession: () => void;
  dispatchResetSchedulingError: () => void;
  dispatchResetSchedulingSuccess: () => void;
  dispatchResetSchedulingMessage: () => void;
  dispatchResetSchedulingStatusCode: () => void;
  dispatchResetClientJobSchedulingTotal: () => void;
  dispatchResetClientJobSchedulingList: () => void;
  dispatchGetClientJobSchedulingList: (
    data: GetClientJobSchedulingListPayloadType
  ) => void;
  dispatchGetAssignedClientsToUserAction: (
    data: GetAssignedClientsToUserPayloadType
  ) => void;
  dispatchGetAllClientAction: (data: getAllClientPayload) => void;
  dispatchGetClientsActiveJobAction: (data: GetJobsPayload) => void;
  dispatchGetClientsFutureJobAction: (data: GetJobsPayload) => void;
  dispatchResetJobListing: () => void;
  dispatchResetFutureJobListing: () => void;

  dispatchGetAllUserMappedToJobAction: (
    data: GetScheduledAllUserMappedToJobPayloadType
  ) => void;
  dispatchresetAllUserMappedToJobList: () => void;
};

export type DropDownItemType = {
  value: number | undefined;
  label: string | undefined;
};
export type ClientListType = {
  value: number | null;
  label: string | null;
};
type sortByUserName = {
  name: string;
  value: string;
};
type getAllClientPayload = {
  token: string;
  offset: number;
  limit: number;
  searchValue: string | undefined;
};
const ClientJobSchedule = ({
  token,
  fetching,
  message,
  error,
  statusCode,
  success,
  totalCount,
  loginData,
  clientList,
  clientJobSchedulingList,
  totalClientsCount,
  totalJobsCount,
  allUserMappedToJob,
  futureJobsList,
  type,
  jobsList,
  dispatchResetClientJobSchedulingList,
  dispatchResetClientJobSchedulingTotal,
  dispatchResetSession,
  dispatchResetSchedulingError,
  dispatchResetSchedulingSuccess,
  dispatchResetSchedulingMessage,
  dispatchResetSchedulingStatusCode,
  dispatchGetClientJobSchedulingList,
  dispatchGetAssignedClientsToUserAction,
  dispatchResetFutureJobListing,
  dispatchGetClientsFutureJobAction,
  dispatchGetAllClientAction,
  dispatchGetAllUserMappedToJobAction,
  dispatchresetAllUserMappedToJobList,
  dispatchGetClientsActiveJobAction,
  dispatchResetJobListing,
}: AppProps) => {
  const { start, end } = getCurrentMonthDates();
  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(20);
  const [showData, setShowData] = useState(false);
  const [selectedJobDetails, setSelectedJobDetails] = useState<any>([]);
  const [jobSelected, setJobSelected] = useState<SelectOptionType>({
    value: null,
    label: "Select Job",
    type: "",
  });
  const [clientSelected, setClientSelected] = useState<any>({
    value: null,
    label: "Select Client",
  });
  const [selectedClient, setSelectedClient] = useState<ClientListType>({
    value: null,
    label: "Select Client",
  });
  const [finalClientList, setFinalClientList] = useState<
    DropDownItemType[] | []
  >([]);
  const [displayStartDate, setDisplayStartDate] = useState("");
  const [displayEndDate, setDisplayEndDate] = useState("");
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);
  const [toggle, setToggle] = useState<boolean>(false);
  const [jobOffset, setJobOffset] = useState<number>(0);
  const [jobText, setJobText] = useState<string>("");
  const [jobLimit, setJobLimit] = useState<number>(20);
  const [sortByJobType, setSortByJobType] = useState({ name: "", value: "" });
  const [sortByUserType, setSortByUserType] = useState({ name: "", value: "" });
  const [sortByTargetEndDate, setSortByTargetEndDate] = useState({
    name: "",
    value: "",
  });
  const [jobStatus, setJobStatus] = useState({ name: "", value: "" });
  const [recentlyAdded, setRecentlyAdded] = useState({
    name: "Recently Added First",
    value: "",
  });
  const [text, setText] = useState<string>("");
  const [loadCondition, setLoadCondition] = useState(true);
  const [finalJobList, setFinalJobList] = useState<any>([]);

  let isRedirected = localStorage.getItem("isRedirected");
  let redirectname = localStorage.getItem("Jobname");
  let redirectstartDate = localStorage.getItem("start_date");
  let redirectendDate = localStorage.getItem("end_date");
  let redirectclientCode = localStorage.getItem("Jobclient_code");

  let redirectedClient = localStorage.getItem("client");
  let isRedirectedType = localStorage.getItem("isRedirected");
  let redirectedJob = localStorage.getItem("job");
  let redirectedStartDate = localStorage.getItem("startDate");
  let redirectedEndDate = localStorage.getItem("endDate");
  const [jobData, setJobData] = useState<any>(
    redirectedJob ? JSON.parse(redirectedJob) : ""
  );

  useEffect(() => {
    dispatchResetSchedulingError();
    dispatchResetSchedulingSuccess();
    dispatchResetSchedulingMessage();
    dispatchResetSchedulingStatusCode();
    dispatchResetClientJobSchedulingList();
    dispatchResetClientJobSchedulingTotal();
    dispatchresetAllUserMappedToJobList();
  }, []);

  useEffect(() => {
    if (token) {
      if (offset <= +totalClientsCount) {
        let finalClientData = {
          token,
          offset,
          limit,
          searchValue: text,
          status: 1,
        };
        dispatchGetAllClientAction(finalClientData);
      }
    }
  }, [offset]);

  useEffect(() => {
    if (
      isRedirected === "ClientJobSchedule" &&
      redirectname &&
      redirectstartDate &&
      redirectendDate &&
      redirectclientCode &&
      clientList?.length > 0
    ) {
      setShowData(true);
      setDisplayStartDate(redirectstartDate);
      setDisplayEndDate(redirectendDate);
      handleStartDateChange(redirectstartDate);
      handleEndDateChange(redirectendDate);
      setClientSelected({ label: redirectname, value: redirectclientCode });
      if (token) {
        let finalData = {
          token,
          client_code: redirectclientCode,
          start_date: formatDate(redirectstartDate),
          end_date: formatDate(redirectendDate),
          job_type_sorted_order: sortByJobType?.value,
          target_end_sorted_order: sortByTargetEndDate?.value,
          job_status_sorted_order: jobStatus?.value,
        };

        dispatchGetClientJobSchedulingList(finalData);
      }

      localStorage.removeItem("isRedirected");
      localStorage.removeItem("Jobname");
      localStorage.removeItem("start_date");
      localStorage.removeItem("end_date");
      localStorage.removeItem("Jobclient_code");
    }

    if (
      isRedirected === "jobSpecificUsers" &&
      redirectedClient &&
      isRedirectedType &&
      redirectedJob &&
      redirectedStartDate &&
      redirectedEndDate
    ) {
      let client = JSON.parse(redirectedClient);
      let redirectedJobData =
        (jobData?.jobId ? `${jobData?.jobId}_` : "") +
        (jobData?.jobType ? `${jobData?.jobType}_` : "") +
        (jobData?.periodEnded
          ? formatDate(jobData?.periodEnded) === "Invalid date"
            ? jobData?.periodEnded
            : formatDate(jobData?.periodEnded)
          : "");
      // let jobData = JSON.parse(redirectedJob);
      setShowData(true);
      setDisplayStartDate(redirectedStartDate);
      setDisplayEndDate(redirectedEndDate);
      handleStartDateChange(redirectedStartDate);
      handleEndDateChange(redirectedEndDate);
      handleChangeClient({ label: client?.label, value: client?.value });
      handleChangeJob({
        label: redirectedJobData,
        value: +jobData?.jobId ? +jobData?.jobId : jobData?.futureJobId,
        type: +jobData?.jobId ? "openJob" : "futureJob",
      });

      if (token) {
        let finalData: GetScheduledAllUserMappedToJobPayloadType = {
          startDate: startDate ? reverseDateFormat(redirectedStartDate) : "",
          endDate: endDate ? reverseDateFormat(redirectedEndDate) : "",
          token,
          clientCode: client?.value,
          job: +jobData?.jobId,
          userSortedOrder: sortByUserType?.value,
          futureJob: jobData?.futureJobId,
        };
        dispatchGetAllUserMappedToJobAction(finalData);
      }

      localStorage.removeItem("client");
      localStorage.removeItem("isRedirected");
      localStorage.removeItem("job");
      localStorage.removeItem("startDate");
      localStorage.removeItem("endDate");
      localStorage.removeItem("periodEnded");
    }
  }, []);

  useEffect(() => {
    dispatchResetClientJobSchedulingList();
    if (
      token &&
      startDate &&
      endDate &&
      clientSelected?.value &&
      type !== "JobSpecificUsersReport"
    ) {
      let finalData = {
        token,
        client_code: clientSelected?.value,
        start_date: startDate ? reverseDateFormat(startDate) : "",
        end_date: endDate ? reverseDateFormat(endDate) : "",
        job_type_sorted_order: sortByJobType?.value,
        target_end_sorted_order: sortByTargetEndDate?.value,
        job_status_sorted_order: jobStatus?.value,
      };
      dispatchGetClientJobSchedulingList(finalData);
    } else if (
      token &&
      startDate &&
      endDate &&
      clientSelected?.value &&
      jobSelected?.value &&
      type === "JobSpecificUsersReport"
    ) {
      let finalData: GetScheduledAllUserMappedToJobPayloadType = {
        startDate: startDate ? reverseDateFormat(startDate) : "",
        endDate: endDate ? reverseDateFormat(endDate) : "",
        token,
        clientCode: clientSelected?.value,
        job: jobSelected?.type == "openJob" ? jobSelected?.value : "",
        futureJob: jobSelected?.type == "futureJob" ? jobSelected?.value : "",
        userSortedOrder: sortByUserType?.value,
      };

      dispatchGetAllUserMappedToJobAction(finalData);
    }
  }, [
    sortByJobType?.name,
    sortByUserType?.name,
    sortByTargetEndDate?.name,
    jobStatus?.name,
  ]);

  const fetchNewData = (search: string) => {
    if (token) {
      const finalData = {
        token,
        offset,
        limit,
        searchValue: text,
        status: 1,
      };
      dispatchGetAllClientAction(finalData);
    }
  };
  useDebounce(
    () => {
      fetchNewData(text);
    },
    500,
    [text]
  );

  useEffect(() => {
    if (clientList?.length > 0) {
      if (offset <= +totalClientsCount) {
        let finalClientData = clientList?.map((user: any) => {
          return {
            value: user.client_code,
            label: `(${user.client_code}) ${user.company_name}`,
          };
        });

        if (offset > 0) {
          setFinalClientList([...finalClientList, ...finalClientData]);
        } else {
          setFinalClientList([...finalClientData]);
        }
      }
    }
  }, [clientList]);

  useEffect(() => {
    if (jobsList?.length > 0 || futureJobsList?.length > 0) {
      let finalJobsData = jobsList?.map((job: any) => {
        return {
          type: "openJob",
          value: job?.job_id,
          label:
            (job?.job_id ? `${job?.job_id}_` : "") +
            (job?.job_type ? `${job?.job_type}_` : "") +
            (job?.period_ended
              ? formatDate(job?.period_ended) === "Invalid date"
                ? job?.period_ended
                : formatDate(job?.period_ended)
              : ""),
        };
      });

      let finalFutureJobsData = futureJobsList?.map((job: any) => {
        return {
          type: "futureJob",
          value: job?._id,
          label:
            (job?.job_type ? `${job?.job_type}_` : "") +
            (job?.period_ended ? job?.period_ended : ""),
        };
      });
      if (finalJobsData?.length > 0 && finalFutureJobsData?.length > 0) {
        setFinalJobList([...finalJobsData, ...finalFutureJobsData]);
      } else if (finalFutureJobsData?.length > 0) {
        setFinalJobList([...finalFutureJobsData]);
      } else if (finalJobsData?.length > 0) {
        setFinalJobList([...finalJobsData]);
      }
    }
  }, [jobsList, futureJobsList]);

  const onMenuClose = () => setLoadCondition(true);

  const handleChangeJob = (job: any) => {
    setJobSelected({ ...job });

    if (jobsList && jobsList?.length) {
      jobsList?.map((item: any) => {
        if (item.job_id === job.value) {
          setSelectedJobDetails(item);
        }
      });
    }
  };

  const checkBottom = (e: any) => {
    setLoadCondition(false);
    setOffset((prv) => prv + limit);
  };
  const handleStartDateChange = (date: string) => {
    const value = handleDate(date);
    setStartDate(value);
  };
  const handleEndDateChange = (date: string) => {
    const value = handleDate(date);
    setEndDate(value);
  };
  const handleChangeClient = (client: any) => {
    setClientSelected(client);
    if (type === "JobSpecificUsersReport") {
      if (client !== clientSelected) {
        setJobSelected({
          value: null,
          label: "Select Job...",
        });
        setFinalJobList([]);
      }
      setClientSelected(client);
      if (client && token) {
        dispatchResetJobListing();
        dispatchResetFutureJobListing();
        let finalData = {
          clientCode: client?.value,
          token,
          filterStatus: "Open",
          search_term: jobText,
        };

        let finalFutureJobData = {
          clientCode: client?.value,
          token,
          search_term: jobText,
        };

        dispatchGetClientsFutureJobAction(finalFutureJobData);

        dispatchGetClientsActiveJobAction(finalData);
      }
    }
  };

  const checkJobTypeBottom = () => {
    setJobOffset((prv: any) => prv + jobLimit);
  };

  const handleSubmit = () => {
    setShowData(true);
    setSelectedClient(clientSelected);
    dispatchResetClientJobSchedulingList();
    if (token) {
      if (type === "JobSpecificUsersReport") {
        let finalData = {
          startDate: startDate ? reverseDateFormat(startDate) : "",
          endDate: endDate ? reverseDateFormat(endDate) : "",
          token,
          clientCode: clientSelected?.value,
          job: jobSelected?.type == "openJob" ? jobSelected?.value : "",
          futureJob: jobSelected?.type == "futureJob" ? jobSelected?.value : "",
          userSortedOrder: sortByUserType?.value,
        };
        dispatchGetAllUserMappedToJobAction(finalData);
      } else {
        let finalData = {
          token,
          client_code: clientSelected?.value,
          start_date: startDate ? reverseDateFormat(startDate) : "",
          end_date: endDate ? reverseDateFormat(endDate) : "",
          job_type_sorted_order: sortByJobType?.value,
          target_end_sorted_order: sortByTargetEndDate?.value,
          job_status_sorted_order: jobStatus?.value,
        };
        dispatchGetClientJobSchedulingList(finalData);
      }
    }
    setDisplayStartDate(handleDate(startDate));
    setDisplayEndDate(handleDate(endDate));
  };
  const handleSetLocalStorageData = (jobData: {
    jobId: string;
    jobType: string;
    periodEnded: string;
  }) => {
    localStorage.setItem("client", JSON.stringify(clientSelected));
    localStorage.setItem("isRedirected", "jobSpecificUsers");
    localStorage.setItem("job", JSON.stringify(jobData));
    localStorage.setItem("startDate", displayStartDate);
    localStorage.setItem("endDate", displayEndDate);
    localStorage.setItem("periodEnded", jobData?.periodEnded);
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
              dispatchResetSchedulingError();
              dispatchResetSchedulingSuccess();
              dispatchResetSchedulingMessage();
            }}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetSchedulingError();
              dispatchResetSchedulingSuccess();
              dispatchResetSchedulingMessage();
            }}
          />
        );
      }
    }

    return false;
  };
  return (
    <>
      <div className="col-md-6">
        <CommonHeader
          title={
            !!type && type?.length > 0 && type === "JobSpecificUsersReport"
              ? "Job Specific User's Report"
              : "Client-Job Scheduling"
          }
        />
      </div>
      <div className="col-md-12 mt-4">
        <div className="new-table-card">
          <div className="header pb-0">
            <div className="left-header">
              <div className="heading">
                {!!type && type?.length > 0 && type === "JobSpecificUsersReport"
                  ? "Job Specific User's Report "
                  : "Client-Job Scheduling "}
                List
                {!showData ? (
                  <> </>
                ) : (
                  <>
                    {!fetching && (
                      <div className="sub-heading mt-0">{`Total ${
                        totalCount ? totalCount : 0
                      } schedules found`}</div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="right-heading position-relative d-flex">
              <div className="ml-2">
                <ClientJobScheduleSorting
                  type={type}
                  sortByJobType={sortByJobType}
                  setSortByJobType={setSortByJobType}
                  setSortByUserType={setSortByUserType}
                  sortByUserType={sortByUserType}
                  sortByTargetEndDate={sortByTargetEndDate}
                  setSortByTargetEndDate={setSortByTargetEndDate}
                  jobStatus={jobStatus}
                  setJobStatus={setJobStatus}
                  recentlyAdded={recentlyAdded}
                  setRecentlyAdded={setRecentlyAdded}
                />
              </div>
            </div>
          </div>
          <div>
            <div className="d-flex align-items-start">
              <div className="col-md-2 pl-3 form-group d-flex flex-column p-0">
                <label className="mb-1">Select Client</label>

                <Select
                  options={finalClientList}
                  value={clientSelected}
                  cacheOptions
                  onChange={handleChangeClient}
                  onMenuScrollToBottom={(e: any) => checkBottom(e)}
                  onInputChange={(e: string) => {
                    setLoadCondition(false);
                    setText(e);
                    setOffset(0);
                  }}
                  onMenuClose={onMenuClose}
                  isLoading={!loadCondition && fetching}
                />
              </div>

              {type === "JobSpecificUsersReport" ? (
                <div className="col-3 ml-3">
                  <label className="mb-1">Select Job</label>
                  <Select
                    className="dropdown"
                    isDisabled={!clientSelected?.value}
                    name="jobType"
                    placeholder={"Search Jobs"}
                    value={jobSelected}
                    options={finalJobList}
                    // components={{ Option }}
                    onChange={handleChangeJob}
                    isSearchable={true}
                    isLoading={fetching}
                    onMenuClose={() => {
                      setJobOffset(0);
                    }}
                    onMenuScrollToBottom={checkJobTypeBottom}
                    onInputChange={(e) => {
                      setJobText(e);
                    }}
                  />
                </div>
              ) : null}

              <div className="form-group ml-3">
                <label className="mb-1">Date</label>
                <div>
                  <ReportsDateSelect
                    setToggle={setToggle}
                    toggle={toggle}
                    startDate={startDate ? startDate : ""}
                    endDate={endDate ? endDate : ""}
                    handleStartDateChange={handleStartDateChange}
                    handleEndDateChange={handleEndDateChange}
                    type={"schedulingReport"}
                    clearEndDate={true}
                  />
                </div>
              </div>

              <div className="ml-3" style={{ marginTop: "29px" }}>
                <button
                  className="btn btn-primary pl-3 pb-2"
                  disabled={
                    !clientSelected?.value ||
                    !startDate?.length ||
                    !endDate?.length ||
                    (type === "JobSpecificUsersReport"
                      ? !jobSelected?.value
                      : false)
                  }
                  onClick={handleSubmit}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
          {!showData ? (
            <div className="mt-5 p-4">
              <EmptyListPage
                title="No Schedule Found!"
                text=""
                imageWidth="30%"
              />
            </div>
          ) : (
            <div>
              <ClientJobScheduleCalendarView
                data={
                  type === "JobSpecificUsersReport"
                    ? allUserMappedToJob
                    : clientJobSchedulingList
                }
                fetching={fetching}
                totalCount={totalCount}
                startDate={startDate}
                endDate={endDate}
                displayStartDate={displayStartDate}
                displayEndDate={displayEndDate}
                clientSelected={clientSelected}
                handleSetLocalStorageData={handleSetLocalStorageData}
                reportType={
                  type === "JobSpecificUsersReport"
                    ? "JobSpecificUsersReport"
                    : "clientJobReport"
                }
              />
            </div>
          )}
        </div>
      </div>
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  message: state.scheduling.message,
  error: state.scheduling.error,
  statusCode: state.scheduling.statusCode,
  success: state.scheduling.success,
  fetching: state.scheduling.fetching,
  clientJobSchedulingList: state.scheduling.clientJobSchedulingList,
  totalCount: state.scheduling.clientJobSchedulingTotal,
  totalClientsCount: state.clientDirectory.totalCount,
  clientList: state.clientDirectory.clientDirectoryList,
  jobsList: state.jobs.jobsList,
  futureJobsList: state.jobs.futureJobsList,
  loginData: state.auth.loginData,
  totalJobsCount: state.jobs.totalJobsCount,
  allUserMappedToJob: state.scheduling.allUserMappedToJob,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSchedulingError: () => dispatch(resetSchedulingError()),
  dispatchResetSchedulingSuccess: () => dispatch(resetSchedulingSuccess()),
  dispatchResetSchedulingMessage: () => dispatch(resetSchedulingMessage()),
  dispatchResetSchedulingStatusCode: () =>
    dispatch(resetSchedulingStatusCode()),
  dispatchResetClientJobSchedulingList: () =>
    dispatch(resetClientJobSchedulingList()),
  dispatchResetClientJobSchedulingTotal: () =>
    dispatch(resetClientJobSchedulingTotal()),
  dispatchGetClientJobSchedulingList: (
    data: GetClientJobSchedulingListPayloadType
  ) => dispatch(getClientJobSchedulingListAction(data)),
  dispatchGetAssignedClientsToUserAction: (
    data: GetAssignedClientsToUserPayloadType
  ) => dispatch(getAssignedClientsToUserAction(data)),
  dispatchGetAllClientAction: (data: getAllClientPayload) =>
    dispatch(getClientDirectoryListAction(data)),
  dispatchGetClientsActiveJobAction: (data: GetJobsPayload) =>
    dispatch(getJobsListAction(data)),
  dispatchGetClientsFutureJobAction: (data: GetJobsPayload) =>
    dispatch(getFutureJobsListAction(data)),
  dispatchGetAllUserMappedToJobAction: (
    data: GetScheduledAllUserMappedToJobPayloadType
  ) => dispatch(getAllUserMappedToJobAction(data)),
  dispatchresetAllUserMappedToJobList: () =>
    dispatch(resetAllUserMappedToJobList()),
  dispatchResetJobListing: () => dispatch(resetJobsList()),
  dispatchResetFutureJobListing: () => dispatch(resetFutureJobsList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientJobSchedule);
